import StrongHealthy from "./StrongHealthy";
export default StrongHealthy